const downClass = ' dir-d ';
const upClass = ' dir-u ';
const regexDir = / dir-(u|d) /;
const regexTable = /\bjs-sortable-table\b/;

function init() {
    document.addEventListener('click', function (e) {
        const element = e.target;

        function reClassify(element, dir) {
            element.className = element.className.replace(regexDir, '') + dir;
        }

        function getValue(element) {
            // If you aren't using data-sort and want to make it just the tiniest bit smaller/faster
            // comment this line and uncomment the next one
            return element.getAttribute('data-sort') || element.innerText;
            // return element.innerText
        }

        if (element.nodeName === 'TH') {
            try {
                const tr = element.parentNode;
                // const table = element.offsetParent; // Fails with positioned table elements
                // this is the only way to make really, really sure. A few more bytes though... 😡
                const table = tr.parentNode.parentNode;
                if (regexTable.test(table.className)) {
                    let columnIndex;
                    const nodes = tr.cells;

                    // reset thead cells and get column index
                    for (let i = 0; i < nodes.length; i++) {
                        // eslint-disable-next-line max-depth
                        if (nodes[i] === element) {
                            columnIndex = i;
                        } else {
                            reClassify(nodes[i], '');
                        }
                    }

                    let dir = downClass;

                    // check if we're sorting up or down, and update the css accordingly
                    if (element.className.indexOf(downClass) !== -1) {
                        dir = upClass;
                    }

                    reClassify(element, dir);

                    // extract all table rows, so the sorting can start.
                    const orgTbody = table.tBodies[0];

                    // get the array rows in an array, so we can sort them...
                    const rows = [].slice.call(orgTbody.rows, 0);

                    const reverse = dir === upClass;

                    // sort them using custom built in array sort.
                    rows.sort(function (a, b) {
                        const x = getValue((reverse ? a : b).cells[columnIndex]);
                        const y = getValue((reverse ? b : a).cells[columnIndex]);
                        // const y = (reverse ? b : a).cells[columnIndex].innerText
                        // const x = (reverse ? a : b).cells[columnIndex].innerText
                        return isNaN(x - y) ? x.localeCompare(y) : x - y;
                    });

                    // Make a clone without content
                    const cloneTbody = orgTbody.cloneNode();

                    // Build a sorted table body and replace the old one.
                    while (rows.length) {
                        cloneTbody.appendChild(rows.splice(0, 1)[0]);
                    }

                    // And finally insert the end result
                    table.replaceChild(cloneTbody, orgTbody);
                }
            } catch (error) {
                // console.log(error)
            }
        }
    });
}

export default {
    init
};
